import { render } from "./OfficeView.vue?vue&type=template&id=59579a68&scoped=true&bindings={}"
import script from "./OfficeView.vue?vue&type=script&lang=ts"
export * from "./OfficeView.vue?vue&type=script&lang=ts"

import "./OfficeView.vue?vue&type=style&index=0&id=59579a68&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-59579a68"

export default script